import {
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  IconButton,
} from '@mui/material';
import Iconify from '../Iconify';
import useResponsive from '../../hooks/useResponsive';

export default function HowItWorks({
  showHowItWorks,
  setShowHowItWorks,
}: {
  showHowItWorks: boolean;
  setShowHowItWorks: (value: boolean) => void;
}) {
  const isSmDown = useResponsive('down', 'sm');

  return (
    <Dialog
      onClose={() => setShowHowItWorks(false)}
      open={showHowItWorks}
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <DialogTitle
        sx={{
          m: 0,
          p: 4,
          display: 'flex',
          justifyContent: 'center',
        }}
      >
        <img src="/logo.png" alt="egg" width="300px" />
        <IconButton
          aria-label="close"
          onClick={() => setShowHowItWorks(false)}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <Iconify
            icon="ep:close-bold"
            id="icon button"
            style={
              // position close button so that it will not overlaps the logo image below xs (600px) viewport size.
              isSmDown
                ? {
                    position: 'absolute',
                    top: 0,
                    right: 0,
                  }
                : undefined
            }
          />
        </IconButton>
      </DialogTitle>
      <DialogContent
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Typography variant="h3" sx={{ mb: 2 }}>
          How it works
        </Typography>
        <Typography>
          Your Alcade account comes with a digital pet for you to care for!
          Candies are received when depositing funds into your account, use
          these candies to improve your pet's Happiness Bar!
        </Typography>
        <img
          src="/images/sidebar/info2.png"
          alt="Alcade"
          style={{
            width: '100%',
            height: '100%',
            marginTop: 20,
            maxWidth: 250,
            borderRadius: 10,
            marginBottom: 20,
            boxShadow: '0px 0px 10px 0px rgba(0, 0, 0, 0.1)',
          }}
        />

        <Typography>
          Once your Happiness Bar is at max, receive a random pet drop! Goal is
          to collect as many pets as you can!
        </Typography>
        <img
          src="/images/sidebar/info1.png"
          alt="Alcade"
          style={{
            width: '100%',
            height: '100%',
            marginTop: 20,
            maxWidth: 250,
            borderRadius: 10,
            boxShadow: '0px 0px 10px 0px rgba(0, 0, 0, 0.1)',
          }}
        />
      </DialogContent>
    </Dialog>
  );
}
